import { ReactNode } from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import DataCoverage from '../DataCoverage/DataCoverage';

export interface OverviewHeaderProps {
  dataReadiness: number;
  logo?: ReactNode;
  description?: string;
  name?: string;
}

export function OverviewHeader({ dataReadiness, logo, description, name }: OverviewHeaderProps) {
  const theme = useTheme();

  return (
    <Stack direction="column" gap={2}>
      <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={2}>
        <Typography variant="h6" fontFamily="Fustat, Arial, sans-serif" color="info.dark">
          data readiness
        </Typography>
        <DataCoverage percentage={dataReadiness} />
      </Stack>
      {logo ? (
        logo
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
          {name && <Typography variant="h2">{name}</Typography>}
        </Box>
      )}
      {description && <Typography variant="h5">{description}</Typography>}
    </Stack>
  );
}
